import {
  ExtensionDetails,
  ExtensionTypeEnum,
  SingleAndSplitPaymentDetails,
} from "src/types";

export const isSingleAndSplitPaymentDetails = (
  extensionDetails: ExtensionDetails,
): extensionDetails is SingleAndSplitPaymentDetails => {
  return (
    extensionDetails.type === ExtensionTypeEnum.CreateSingleAndSplitPayments
  );
};
